<div *ngIf="visible" class="message bot faded-message doc-markdown">
  <markdown
    class="welcome-message-markdown"
    [data]="welcomeMessage"
    (click)="handleWelcomeClick($event)"
    katex
  >
  </markdown>
</div>